import React, { PropsWithChildren } from "react";
import { SafeAreaView } from "react-native-safe-area-context";
import { KeyboardProvider } from "react-native-keyboard-controller";

const SafeAreaManager = ({ children }: PropsWithChildren) => {
    return (
        <SafeAreaView
            style={{ flex: 1 }}
            edges={{
                bottom: "off",
                top: "off",
                left: "additive",
                right: "additive",
            }}
        >
            <KeyboardProvider>{children}</KeyboardProvider>
        </SafeAreaView>
    );
};

export default SafeAreaManager;
